<template>
<div class="c-buffer-box c-buffer-box--vertical c-buffer-box--super-tight-top-ends t-border-green">
    <form @submit.prevent="handleSubmit" class="c-form">
        <fieldset>
            <div class="o-grid">
                <div data-size="sm:10 md:10 lg:10" class="o-grid__column t-margin-bottom-s">
                    <fieldset class="c-radio-group" ref="courseType">
                        <div class="c-radio c-radio--inline">
                            <input type="radio" name="type" :checked="courseType !== 'Certification'" value="Course" class="c-radio__input" :id="courseRadioId">
                            <label :for="courseRadioId" class="c-radio__label">Kurs</label>
                        </div>
                        <div class="c-radio c-radio--inline">
                            <input type="radio" name="type" :checked="courseType === 'Certification'" value="Certification" class="c-radio__input" :id="certificationRadioId">
                            <label :for="certificationRadioId" class="c-radio__label">Intyg/certifikat</label>
                        </div>
                    </fieldset>
                </div>
				<div data-size="sm:2 md:2 lg:2" class="[ o-grid__column o-grid__column--align-center ] t-margin-bottom-s">
					<div class="t-text-align-right">
						<div v-if="status === 'Expired'" class="c-notify-pill" title="Löpt ut"><span>Löpt ut</span></div>
						<div v-else-if="status === 'Expiring'" class="c-notify-pill" title="Löper snart ut"><span>Löper snart ut</span></div>
					</div>
				</div>
                <div data-size="sm:12 md:4 lg:4" class="o-grid__column t-margin-bottom-s">
                    <dropdown-variations :item-groups="courseOptions" label="Välj kurskategori" :value="category" ref="category"  :allow-custom-value="true" :filterable="true"></dropdown-variations>
                </div>
                <div data-size="sm:12 md:8 lg:8" class="o-grid__column t-margin-bottom-xs">
                    <div class="c-form__item">
                        <vue-input label="Namn på kurs/certifiering" :input-id="'name-' + id" :value="name" ref="name"></vue-input>
                    </div>
                </div>
                <div data-size="sm:12 md:6 lg:6" class="o-grid__column t-margin-bottom-xs">
                    <div class="c-form__item">
                        <vue-input label="Utfärdare/Arrangör" :input-id="'issuer-' + id" :value="issuer" ref="issuer"></vue-input>
                    </div>
                </div>
				<div data-size="sm:12 md:6 lg:6" class="o-grid__column t-margin-bottom-xs">
                    <div class="c-form__item">
					    <date-input label="Kurs-/utfärdandedatum (åååå-mm-dd)" :input-id="'issued-' + id" :value="issued" ref="issued" />
                    </div>
                </div>
                <div data-size="sm:12 md:7 lg:7" class="o-grid__column t-margin-bottom-xs">
                    <div class="c-form__item">
                              <fieldset class="c-radio-group" ref="validTo">
                        <div class="o-grid o-grid--align-center  c-coworker-course__radiogroup">           
                            <div class="c-radio t-margin-right-s">
                                <input type="radio" name="validyToDate" v-on:change="shouldInputBeEnabled" :checked="!expires || (validTo && validTo.type && validTo.type === 'UntilFurtherNotice')" class="c-radio__input" :id="`permanent-${this.id}`" value="UntilFurtherNotice">
                                <label :for="`permanent-${this.id}`" class="c-radio__label">Giltig tills vidare</label>
                            </div>
                            <div class="c-radio t-margin-right-s">
                                <input type="radio" name="validyToDate" v-on:change="shouldInputBeEnabled" :checked="expires || (validTo && validTo.type && validTo.type === 'ExpiresAt')" value="ExpiresAt" class="c-radio__input" :id="`date-${this.id}`">
                                <label :for="`date-${this.id}`" class="c-radio__label">Giltig till datum</label>
                            </div>
                             <date-input label="Datum (åååå-mm-dd)" :required="enableInput" :disabled="!enableInput" :input-id="'date-' + id" :value="expires ? formatDate(expires) : ''" ref="date" />
                        </div>   
                    </fieldset>
                    </div>      
                </div>
				<div data-size="sm:12 md:5 lg:5" class="o-grid__column t-margin-bottom-xs">
                    <div class="c-form__item">
					   <vue-input label="Länk till kursbevis" :required="false" :input-id="'certificationLink-' + id" :value="certificationLink" ref="certificationLink" /> 
                    </div>
                </div>       
                <div v-if="displayHandleExpiration" data-size="sm:12 md:12 lg:12" class="o-grid__column">
                    <vue-input
                        type="checkbox"
                        label="Giltighet/utgång hanterad"
                        :inputId="`expirationHandleMode-${courseId}`"
                        :checked="(expirationHandleMode === 'Handled') ? 'checked' : null"
                        ref="expirationHandleMode">
                    </vue-input>
                </div>
                <div data-size="sm:12 md:12 lg:12" class="o-grid__column">
                    <vue-input
                        type="checkbox"
                        label="Visa på kompetenskort"
                        :inputId="`printOption-${courseId}`"
                        :checked="(printOption === 'Display') ? 'checked' : null"
                        ref="printOption">
                    </vue-input>
                </div>
            </div>
            <div class="o-grid">
                <div data-size="sm:12 md:6 lg:6" class="o-grid__column">
                    <div class="t-margin-bottom-xs t-margin-top-m t-text-align-left">
                        <button v-if="mode === 'edit'" type="submit" class="c-button c-button--linkstyle c-button--linkstyle__secondary c-button--reset" @click="toggleDeleteModal">Ta bort kurs/intyg</button>
                    </div>
                </div>
                <modal :show="showDeleteModal" @closeModal="toggleDeleteModal">
                    <div class="c-modal__content t-background-white t-text-align-center">
                        <h1 class="t-text-style-alpha t-margin-bottom-s">Du tar nu bort kursen/intyget "{{name}}"</h1>
                        <form @submit.prevent="handleSubmit" class="c-form">
                            <button class="c-button c-button--linkstyle c-button--reset t-margin-top-m" @click="toggleDeleteModal">Avbryt</button>
                            <button type="submit" class="c-button c-button--primary t-margin-top-m" @click="setSubmitType('delete')">Ta bort</button>
                        </form>
                    </div>
                </modal>
                <div data-size="sm:12 md:6 lg:6" class="o-grid__column">
                    <div class="t-margin-bottom-xs t-margin-top-s t-text-align-right">
                        <button v-if="mode === 'create'" type="button" class="c-button c-button--linkstyle c-button--reset" @click.prevent="cancelAddCourse">Avbryt</button>
                        <button v-if="mode === 'create'" type="submit" class="c-button c-button--primary" @click="setSubmitType('create')">Spara</button>
                        <button v-if="mode === 'edit'" type="button" class="c-button c-button--linkstyle c-button--reset" @click.prevent="cancelEditCourse">Avbryt</button>
                        <button v-if="mode === 'edit'" type="submit" class="c-button c-button--primary" @click="setSubmitType('edit')">Spara</button>
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</div>
</template>

<script>
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';
import DateInput from '@/components/vue-components/date-input/DateInput.vue';
import Modal from '@/components/vue-components/modal/Modal.vue';
import DropdownVariations from '@/components/vue-components/dropdown-variations/DropdownVariations.vue';
export default {
    name: 'CompetenceCardCourse',
    components: {
        VueInput,
        DateInput,
        Modal,
		DropdownVariations
    },
    props: {
        mode: {
            type: String,
            default: ''
        },
        competenceCardId: {
            type: String,
            default: '0'
        },
        id: {
            type: String,
            default: '0'
        },
        name: {
            type: String,
            default: ''
        },
        category: {
            type: String,
            default: ''
        },
        courseType: {
            type: String,
            default: ''
        },
        issuer: {
            type: String,
            default: ''
        },
        issued: {
            type: String,
            default: ''
        },
        certificationLink:{
            type:String,
            default:''
        },
		expires: {
			type: String,
			default: ''
        },
        expirationHandleMode: {
            type: String,
            default: 'Unhandled'
        },
        validTo: {
            type: Object,
            default: () => {}
        },
		printOption: {
			type: String,
			default: 'Display'
		},
		courseOptions: {
			type: Array,
			default: () => []
        },
        status: {
            type: String,
            required: false
        }
    },
    data() {
        return {
			showDeleteModal: false,
			enableInput: false,
        }
    },
    computed: {
        courseRadioId() {
            return `type-course-${this.id}`
        },
        certificationRadioId() {
            return `type-certification-${this.id}`
        },
        displayHandleExpiration () {
            return (
                this.status === 'Expiring' ||
                this.status === 'Expired'
            );
        }
    },
    methods: {
        validateDate(e) {
            const invalidDate = isNaN(new Date(e.target.value));

            if (invalidDate) {
                e.target.setCustomValidity('Ogiltigt datum');
            }
            else {
                e.target.setCustomValidity('');
            }
        },
        setSubmitType(type) {
            this.submitType = type;
        },
        handleSubmit() {
            switch (this.submitType) {
                case 'create':
                    this.create();
                    break;
                case 'edit':
                    this.edit();
                    break;
                case 'delete':
                    this.delete();
                    break;
            }
        },
        create() {
            this.$emit('addCourse', {
                competenceCardId: this.competenceCardId,
                name: this.$refs.name.getValue(),
                category: this.$refs.category.getValue(),
                courseType: this.$refs.courseType.querySelector('input[name="type"]:checked').value,
                issuer: this.$refs.issuer.getValue(),
				issued: this.$refs.issued.getValue(),
				expires: this.$refs.date.getValue(),
                printOption: (this.$refs.printOption.getValue()) ? 'Display' : 'Hide',
                certificationLink: this.formatCertificationlink()
            });
            this.cancelAddCourse();
        },
        edit() {
            this.$emit('editCourse', {
                competenceCardId: this.competenceCardId,
                courseId: this.id,
                name: this.$refs.name.getValue(),
                category: this.$refs.category.getValue(),
                courseType: this.$refs.courseType.querySelector('input[name="type"]:checked').value,
                issuer: this.$refs.issuer.getValue(),
				issued: this.$refs.issued.getValue(),
                expires: this.$refs.date.getValue(),
                expirationHandleMode: (this.$refs.expirationHandleMode && this.$refs.expirationHandleMode.getValue()) ? 'Handled' : 'Unhandled',
                printOption: (this.$refs.printOption.getValue()) ? 'Display' : 'Hide',
                certificationLink: this.formatCertificationlink()
            });
            this.cancelEditCourse();
        },
        delete() {
            this.$emit('deleteCourse', {
                competenceCardId: this.competenceCardId,
                courseId: this.id
            });
            this.toggleDeleteModal();
        },
        cancelEditCourse() {
            this.$emit('cancelEditCourse', this.id);
        },
        toggleDeleteModal() {
            this.showDeleteModal = !this.showDeleteModal;
        },
        cancelAddCourse() {
            this.$emit('cancelAddCourse');
		},
		shouldInputBeEnabled(event) {
			let type = event.target.value;
			this.enableInput = (type === 'ExpiresAt');
			this.validTo = { type: type };
			if (event.target.value === 'ExpiresAt') {
				this.validTo = { type: 'ExpiresAt' };
				this.enableInput = true;
			} else {
				if(this.validTo) this.validTo.date = '';
				this.expires = this.validTo.date;
				this.enableInput = false;
			}
			return this.enableInput;
		},
		formatDate(issued) {
			let dateString = new Date(issued).toLocaleDateString('sv-SE');
			return dateString;
        },      
        formatCertificationlink(){
       var link=this.$refs.certificationLink.getValue()
       if(link === "")
       {
            return link;
       }
       else if(link.indexOf("http://") > -1)
       {
           return link;
       }
       else if(link.indexOf("https://") > -1)
       {
             return link;
       }
       else
       {
           return "http://"+link;
       }  
        return link;
    }
	},
	created() {
		if (this.expires) {
			this.enableInput = true;
		}
    }  
}
</script>
